import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  updateProfile,
  changePassword,
  getApiKeys,
  createApiKey,
  deleteApiKey,
  getNotificationPreferences,
  updateNotificationPreferences,
  updateOptionalFeature,
  getGoogleAccountStatus,
  disconnectGoogleAccount,
} from '../api/settings';

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth', 'me'] });
    },
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: changePassword,
  });
}

export function useApiKeys() {
  return useQuery({
    queryKey: ['apiKeys'],
    queryFn: getApiKeys,
  });
}

export function useCreateApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });
}

export function useDeleteApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });
}

export function useNotificationPreferences() {
  return useQuery({
    queryKey: ['notificationPreferences'],
    queryFn: getNotificationPreferences,
  });
}

export function useUpdateNotificationPreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateNotificationPreferences,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notificationPreferences'] });
    },
  });
}

export function useUpdateOptionalFeature() {
  return useMutation({
    mutationFn: updateOptionalFeature,
  });
}

export function useGoogleAccountStatus() {
  return useQuery({
    queryKey: ['googleAccountStatus'],
    queryFn: getGoogleAccountStatus,
  });
}

export function useDisconnectGoogleAccount() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disconnectGoogleAccount,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['googleAccountStatus'] });
    },
  });
}
